import { useMutation, useQueryClient } from "@tanstack/react-query";
import { notification } from "antd";
import { PasswordSetupPayload } from "./dto";
import { enumeratorClient } from "config/axios";
import PATHS from "config/paths";
import { QueryKeys } from "config/query-keys";

export const passwordSetup = (data: PasswordSetupPayload): Promise<{}> => {
  return enumeratorClient.httpClient.post(PATHS.enumerator.changePassword.passwordSetup, data);
};

export const useEnumeratorPasswordSetup = () => {
  const queryClient = useQueryClient();

  return useMutation({
    onSuccess: async (data, __, ___) => {
      await queryClient.invalidateQueries({ queryKey: [QueryKeys.ENUMERATOR] });
      notification.success({
        message: "Completed",
        description: "Password setup successfully completed.",
      });
    },

    mutationFn: passwordSetup,
  });
};
